import {LegalDocumentPage} from 'attendee/LegalDocumentPage'
import React from 'react'
import {routes} from 'routes/routes'

export function CookiesPolicy() {
  return (
    <LegalDocumentPage
      slug="cookies"
      routePath={routes.cookies}
      i18nPrefix="legal.cookies"
    />
  )
}
